(function () {
    const accordion = document.querySelectorAll(".accordion > .accordion__title");

    if (accordion) {
        accordion.forEach(item => {
            item.addEventListener('click', (e) => {
                const self = e.currentTarget
                const panel = self.nextElementSibling;

                self.classList.toggle('accordion__title_active');

                if (panel.style.maxHeight) {
                    panel.style.maxHeight = null;
                } else {
                    panel.style.maxHeight = panel.scrollHeight + 'px';
                }
            });
        })
    }
}());
